import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { Layout } from './components/Layout';
import { RequireAuth } from './components/RequireAuth';
import { SignIn } from './pages/SignIn';
import { AuthCallback } from './pages/AuthCallback';
import { Jobs } from './pages/Jobs';
import { JobNew } from './pages/JobNew';
import { JobDetail } from './pages/JobDetail';
import { Settings } from './pages/Settings';
import { Collect } from './pages/Collect';
import { ClientForm } from './pages/ClientForm';
import { Etoe } from './pages/Etoe';


/** Old client links point at /upload/:token. Same token, new page. */
function LegacyUploadRedirect() {
  const { token = '' } = useParams();
  return <Navigate to={`/collect/${token}`} replace />;
}

export function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/signin" element={<SignIn />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/etoe/:token" element={<Etoe />} />
      {/*
        Collect information: one link, two tabs. /upload is kept as a permanent
        redirect because links sitting in clients' inboxes have to keep working; the
        token is the same, only the page behind it changed.
      */}
      <Route path="/collect/:token" element={<Collect />} />
      <Route path="/upload/:token" element={<LegacyUploadRedirect />} />
      <Route path="/client/:token" element={<ClientForm />} />

      {/* Authenticated */}
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/jobs/new" element={<JobNew />} />
        <Route path="/jobs/:id" element={<JobDetail />} />
        <Route path="/settings" element={<Settings />} />
      </Route>

      <Route path="/" element={<Navigate to="/jobs" replace />} />
      <Route path="*" element={<Navigate to="/jobs" replace />} />
    </Routes>
  );
}
